import React, { FC } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import MapSettingsPage from './MapSettingsPage';

const MapSettingsFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <MapSettingsPage />
        </AuthCheck>
      </Route>

      {/*
        Marker categories used to be their own pages. They are accordion
        groups inside the sheet now, so old links land back on the sheet.
      */}
      <Route path={`${path}/:markerGroup`}>
        <Redirect to={path} />
      </Route>
    </Switch>
  );
};

export default MapSettingsFeature;
